import getLocalString from "constants/Localization";
import {
  CustomGetProposalDocument,
  Proposal,
  CustomDuplicateProposalStageMutation,
  CustomDuplicateProposalStageMutationVariables,
  useCustomDuplicateProposalStageMutation,
} from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useDuplicateProposalStage({ proposalId }: { proposalId: Proposal["id"] }) {
  const [mutation, { loading, error, data }] = useCustomDuplicateProposalStageMutation({
    refetchQueries: [
      {
        query: CustomGetProposalDocument,
        variables: { id: proposalId },
      },
    ],
  });

  const [duplicateProposalStage, context] = useBitumioMutation<
    CustomDuplicateProposalStageMutationVariables,
    CustomDuplicateProposalStageMutation,
    "duplicateProposalStage"
  >(
    {
      mutation,
      loading,
      error,
      data,
      key: "duplicateProposalStage",
    },
    {
      successMessage: getLocalString("proposals.duplicate-proposal-stage-success"),
      failureMessage: getLocalString("proposals.duplicate-proposal-stage-failure"),
    }
  );

  return [duplicateProposalStage, context] as const;
}
